import { take, put, fork } from 'redux-saga/effects';
import { NotificationManager } from 'react-notifications';

import * as appActions from '../actions';

const notificationsListener = () => function* notifications() {
	while (true) {
		const notification = yield take(appActions.ui.uiActionTypes.NOTIFICATION);
		const {
			type = 'info',
			title = '',
			message = '',
			timeOut = 0,
			priority = false,
			action,
		} = notification.payload;
		const callback = function* cb() {
			if (action) {
				yield put(action);
			}
		};
		switch (type) {
			case 'info':
				NotificationManager.info(
					message,
					title,
					timeOut,
					callback,
					priority
				);
				break;
			case 'success':
				NotificationManager.success(
					message,
					title,
					timeOut,
					callback,
					priority
				);
				break;
			case 'warning':
				NotificationManager.warning(
					message,
					title,
					timeOut,
					callback,
					priority
				);
				break;
			case 'error':
				NotificationManager.error(
					message,
					title,
					timeOut,
					callback,
					priority
				);
				break;
			default:
				break;
		}
	}
};

export default [
	fork(notificationsListener()),
];



// WEBPACK FOOTER //
// ./src/sagas/ui.js